// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_os-5";
export var filledCircle = "_os-4";
export var historyEntry = "_os-3";
export var messageSideLeft = "_os-1";
export var messageSideRight = "_os-2";
export var orderTrackingCarouselWrapper = "_os-6";
export var orderTrackingInfoContainer = "_os-0";